import axiosInstance from "../axios";

const TRANSCRIBE_ENDPOINT = "/api/transcribe";

export const getTranscriptionData = async (
  userId,
  assessmentId,
  userType,
  recordid
) => {
  try {
    const response = await axiosInstance.get(
      recordid
        ? `${TRANSCRIBE_ENDPOINT}/experience/get-transcription`
        : `${TRANSCRIBE_ENDPOINT}/get-transcription`,
      {
        params: recordid
          ? {
              recordid: recordid,
            }
          : {
              userid: userId,
              usertype: userType,
              assessmentid: assessmentId,
            },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(
      "Error fetching transcription data: " + error.message
    );
  }
};